<script>
import { apiClient, validationService } from '@services'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import TabsContainer from '@components/tabs/tabs-container'
import TabsContent from '@components/tabs/tabs-content'
import TabsNav from '@components/tabs/tabs-nav'
import TurnstileEditor from '@components/layout/turnstile/turnstile-editor'
import VueLoader from '@components/loader/VueLoader'
import { SweetModal } from 'sweet-modal-vue'
import CtaPreview from '@components/layout/ctaPreview/cta-preview'
import { GET_PROJECT_BY_ID } from '../../../constants/endponts'
import { VueEditor } from 'vue2-editor'

export default {
  page: {
    title: 'Channel Settings',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    TabsContainer,
    TabsContent,
    TabsNav,
    TurnstileEditor,
    VueLoader,
    SweetModal,
    CtaPreview,
    VueEditor,
  },
  data() {
    return {
      saved: false,
      breadcrumbs: [
        {
          name: '',
          path: '/channels',
        },
        {
          name: 'Channel Settings',
          path: '#',
          active: true,
        },
      ],
      loading: true,
      form: {},
      projectId: this.$route.params.projectId,
      project: null,
      linksNav: [
        {
          id: 'projectSettings',
          name: 'Channel Settings',
        },
        {
          id: 'authorSettings',
          name: 'Author Settings',
        },
        {
          id: 'defaultFunctions',
          name: 'Default Video CTA',
        },
      ],
      turnstileInfo: {},
      keywordTag: null,
      disableUpdateButton: false,
    }
  },
  created() {
    this.getProject()
  },
  methods: {
    getProject() {
      apiClient
        .get(GET_PROJECT_BY_ID(this.projectId))
        .then((res) => {
          this.project = res.data
          this.turnstileInfo = res.data.turnstile
          this.breadcrumbs[0].name = res.data.name
          this.loading = false
          this.form = JSON.parse(JSON.stringify(res.data))
          this.$store.commit('users/SET_CURRENTPROJECT', res.data)
        })
        .catch((err) => {
          return err
        })
    },
    trim(val) {
      return String(val).replace(/^\s+|\s+$/g, '')
    },
    openModal(modal) {
      this.$refs[modal].open()
    },
    closeModal(modal) {
      this.$refs[modal].close()
    },
    openLink(url) {
      window.open(url, '_blank')
    },
    updateProjectSettings() {
      // TODO: Finish writing this function to update the Project Settings information on the first tab.

      const cover = this.$refs.coverInput
      const background = this.$refs.backgroundInput
      const coverFile = cover.files
      const backgroundFile = background.files

      let formData = new FormData()
      formData.append('description', this.form.description)
      // formData.append('published', this.form.published)
      formData.append('tags', JSON.stringify(this.form.tags))
      formData.append('name', this.form.name)
      formData.append('visible', this.form.visible)

      if (coverFile[0]) {
        formData.append('app_icon', coverFile[0])
      }

      if (backgroundFile[0]) {
        formData.append('background_image', backgroundFile[0])
      }

      const projectInfo = {
        projectName: this.form.title,
        file: this.form.videoData,
      }

      const errors = validationService.validateAll(projectInfo)
      this.errors = errors

      this.errorsToState(errors).then(() => {
        const result = validationService.validateState(projectInfo, this.errors)
        if (result.emptyValues.length > 0 || result.errors.length > 0) {
          return false
        } else {
          this.secondaryLoading = true
          this.updateProjectData(formData)
        }
      })
    },

    errorsToState(errorValue, callback) {
      let error = errorValue
      const promise = new Promise((resolve) => {
        for (error in this.errors) {
          if (errorValue[error] !== undefined) {
            this.errors[error] = errorValue[error]
          }
        }

        resolve()
      })
      return promise
    },

    updateProjectData(data) {
      this.disableUpdateButton = true
      apiClient
        .patch(GET_PROJECT_BY_ID(this.projectId), data)
        .then((res) => {
          this.form = res.data
          this.showSaved()
          this.disableUpdateButton = false
        })
        .catch((err) => {
          this.disableUpdateButton = false
          return err
        })
    },
    showSaved() {
      this.saved = true
      setTimeout(() => {
        this.saved = false
      }, 1000)
    },
    addTag(tag) {
      const array = this.form.tags
      tag = this.trim(tag)
      var index = array.indexOf(tag)
      if (index === -1) {
        this.form.tags.push(tag)
      }

      this.keywordTag = ''
    },
    deleteTag(tag) {
      const array = this.form.tags
      var index = array.indexOf(tag)
      if (index > -1) {
        array.splice(index, 1)
      }
    },
    onCoverChange(e) {
      const reader = new FileReader()
      const input = this.$refs.coverInput
      const files = input.files
      reader.onload = (e) => {
        this.form.app_icon = reader.result
      }
      reader.readAsDataURL(files[0])
      this.$emit('input', files[0])
    },
    onBackgroundChange(e) {
      const reader = new FileReader()
      const input = this.$refs.backgroundInput
      const files = input.files
      reader.onload = (e) => {
        this.form.background_image = reader.result
      }
      reader.readAsDataURL(files[0])
      this.$emit('input', files[0])
    },
    onSelectFile(refInput) {
      const input = this.$refs[refInput]

      const files = input.files

      if (files && files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          if (refInput === 'backgroundInput') {
            this.form.background_image = reader.result
          } else {
            this.form.app_icon = reader.result
          }
        }
        reader.readAsDataURL(files[0])
        this.$emit('input', files[0])
      }
    },
    chooseImage(refInput) {
      this.$refs[refInput].click()
    },
    deleteProject() {
      apiClient
        .delete(GET_PROJECT_BY_ID(this.projectId))
        .then((res) => {
          this.$router.push('/channels')
          return res
        })
        .catch((err) => {
          return err
        })
    },
  },
}
</script>

<template>
  <Layout v-if="loading">
    <VueLoader />
  </Layout>
  <Layout
    v-else
    :list="breadcrumbs"
    :full-height="true"
    class="bg-white"
    :content-padding="'pt4 pb-0'"
  >
    <div class="content-list settings">
      <div class="bg-white py-4 h-100 position-relative">
        <h2 class="text-secondary font-weight-bold px-4 mb-3">{{
          project.name
        }}</h2>

        <TabsContainer>
          <template v-slot:tabsNavbar>
            <TabsNav :vertical-nav="false" :links="linksNav" />
          </template>

          <template v-slot:tabsContent>
            <TabsContent :vertical-nav="false" :class="'py-0'">
              <!-- Project settings -->
              <div
                id="projectSettings"
                class="tab-pane project-settings active pt-0"
                role="tabpanel"
                aria-labelledby="projectSettings-tab"
              >
                <div>
                  <div class="mb-5">
                    <div class="border col-sm-12 col-md-6 px-5 py-4">
                      <div class="card-body">
                        <!-- Form for Adding Content -->
                        <form action="" class="px-sm-5">
                          <!-- Project Name -->
                          <div class="form-group">
                            <label for="projectName">
                              <small>Channel Name</small>
                            </label>
                            <BaseInputText
                              v-model="form.name"
                              name="projectName"
                              :placeholder="`Enter your project name here`"
                            />
                          </div>
                          <small
                            v-if="!form.name"
                            class="text-danger d-block mb-3"
                          >
                            * This field is required
                          </small>

                          <!-- description -->
                          <div class="form-group">
                            <label for="description">
                              <small>Description</small>
                            </label>
                            <VueEditor
                              v-model="form.description"
                              placeholder="Enter the description for content"
                            ></VueEditor>
                            <!--
                            <textarea
                              v-model="form.description"
                              rows="5"
                              cols="50"
                              class="form-control"
                              placeholder="Enter the description for content"
                            />
                            -->
                          </div>

                          <!-- Website Link -->
                          <div class="form-group">
                            <label for="website">
                              <small>Website Link</small>
                            </label>
                            <BaseInputText
                              v-model="form.website"
                              name="website"
                              :placeholder="
                                `full URL required https://www.example.com`
                              "
                            />
                          </div>

                          <!-- Publisher -->
                          <div class="form-group">
                            <label for="publisher">
                              <small
                                >Publisher - Who creates your content?</small
                              >
                            </label>
                            <BaseInputText
                              v-model="form.publisher && form.publisher.name"
                              name="publisher"
                              :placeholder="
                                `Needed if you create a video channel`
                              "
                            />
                          </div>

                          <!-- Background Image -->
                          <div class="card card-cover-image mb-4">
                            <div class="card-header bg-white p-0 pb-2">
                              <small>Background Image</small>
                            </div>
                            <div
                              class="upload-area upload-area-sm overflow-hidden"
                            >
                              <div class="form-group h-100 w-100 m-0">
                                <div
                                  id="uploadFile"
                                  class="upload-container h-100"
                                >
                                  <div id="test"></div>
                                  <div
                                    class="upload-input w-100 h-100"
                                    @click="chooseImage('backgroundInput')"
                                  >
                                    <div
                                      class="upload-placeholder d-flex justify-content-center align-items-center bg-black"
                                    >
                                      <div
                                        v-if="form.background_image === null"
                                      >
                                        <img
                                          src="@assets/images/uploadPrimary.svg"
                                          alt=""
                                          class="mb-3"
                                          height="30px"
                                        />
                                        <br />
                                        <small class="d-block"
                                          >Upload a new background image</small
                                        >
                                      </div>

                                      <div
                                        v-else
                                        class="w-100 h-100"
                                        :style="{
                                          'background-image': `url(${form.background_image})`,
                                          'background-size': 'cover',
                                          'background-position': 'center',
                                        }"
                                      >
                                      </div>
                                    </div>
                                    <div id="progressNumber"></div>
                                    <input
                                      ref="backgroundInput"
                                      class="file-input"
                                      type="file"
                                      @change="onBackgroundChange"
                                      @input="onSelectFile('backgroundInput')"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Cover Image -->
                          <div class="card card-cover-image mb-4">
                            <div class="card-header bg-white p-0 pb-2">
                              <small
                                >Channel Logo (1400x1400 px recommended)</small
                              >
                            </div>
                            <div
                              class="upload-area upload-area-sm overflow-hidden"
                            >
                              <div class="form-group h-100 w-100 m-0">
                                <div
                                  id="uploadFile"
                                  class="upload-container h-100"
                                >
                                  <div id="test"></div>
                                  <div
                                    class="upload-input w-100 h-100"
                                    @click="chooseImage('coverInput')"
                                  >
                                    <div
                                      class="upload-placeholder d-flex justify-content-center align-items-center bg-black"
                                    >
                                      <div v-if="form.app_icon === null">
                                        <img
                                          src="@assets/images/uploadPrimary.svg"
                                          alt=""
                                          class="mb-3"
                                        />
                                        <br />
                                        <small class="d-block"
                                          >Upload a cover image.</small
                                        >
                                      </div>

                                      <div
                                        v-else
                                        class="w-100 h-100"
                                        :style="{
                                          'background-image': `url(${form.app_icon})`,
                                          'background-size': 'cover',
                                          'background-position': 'center',
                                        }"
                                      >
                                      </div>
                                    </div>
                                    <div id="progressNumber"></div>
                                    <input
                                      ref="coverInput"
                                      class="file-input"
                                      type="file"
                                      @change="onCoverChange('coverInput')"
                                      @input="onSelectFile('coverInput')"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- content url -->
                          <!-- <div class="form-group">
                                <label for="content_url">
                                  <small>Content Url</small>
                                </label>
                                <BaseInputText
                                  v-model="form.content_url"
                                  class="form-control bg-white"
                                  name="content_url"
                                  :placeholder="`Start here`"
                                />
                              </div> -->
                          <!-- keyword tags -->
                          <div class="form-group">
                            <label for="tags">
                              <small>Add keyword tags</small>
                            </label>
                            <div
                              v-if="form.tags.length > 0"
                              class="tags-container mb-3"
                            >
                              <span
                                v-for="tag in form.tags"
                                :key="tag"
                                class="badge badge-purple font-weight-normal mr-2 mb-1"
                              >
                                {{ tag }}
                                <small
                                  class="ml-2 btn-close"
                                  @click.prevent="deleteTag(tag)"
                                  ><BaseIcon name="times"
                                /></small>
                              </span>
                            </div>
                            <div class="input-group">
                              <BaseInputText
                                v-model="keywordTag"
                                class="form-control bg-white"
                                name="keywordTag"
                                :placeholder="`Type any keyword`"
                              />
                            </div>
                          </div>

                          <div
                            class="col-sm-12 d-flex justify-content-end align-items-center mb-4 px-0"
                          >
                            <!-- <div class="form-group">
                              <div class="input-group">
                                <select
                                  v-model.number="form.publish_status"
                                  type="number"
                                  class="form-control select-sm"
                                >
                                  <option value="0">Draft</option>
                                  <option value="1">Private</option>
                                  <option value="2">Public</option>
                                </select>
                              </div>
                            </div> -->
                            <button
                              class="btn btn-purple float-right px-2"
                              :disabled="!keywordTag || keywordTag.length === 0"
                              @click.prevent="addTag(keywordTag)"
                              >Add Tag
                            </button>
                          </div>

                          <!-- Check for Visible -->

                          <div
                            class="custom-control custom-checkbox custom-checkbox w-100"
                          >
                            <input
                              id="visible"
                              v-model="form.visible"
                              type="checkbox"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label d-block"
                              for="visible"
                            >
                              <small class="text-gray-light font-weight-normal">
                                Visible in list of shows
                              </small>
                            </label>
                          </div>

                          <div class="mt-4 mb-0">
                            <div
                              class="form-group d-flex pt-4 pb-0 mb-0 align-items-center justify-content-between"
                            >
                              <button
                                class="btn btn-outline text-gray-input mr-2"
                                @click.prevent="openModal('modal')"
                              >
                                <span class="h5 font-weight-light">
                                  Remove Channel
                                </span>
                              </button>
                              <span
                                v-if="saved"
                                class="badge badge-purple font-weight-normal mr-2 mb-1"
                              >
                                <small class="ml-2 btn-close"
                                  ><BaseIcon name="check"
                                /></small>
                              </span>
                              <button
                                class="btn btn-primary font-weight-normal px-4"
                                :disabled="disableUpdateButton"
                                @click.prevent="updateProjectSettings"
                              >
                                Update Channel
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Author Settings -->
              <div
                id="authorSettings"
                class="tab-pane authorSettings pt-0"
                role="tabpanel"
                aria-labelledby="authorSettings-tab"
              >
                <div>
                  <div class="mb-5">
                    <div class="border col-sm-12 col-md-6 px-5 py-4">
                      <div class="form-container px-0 px-md-5">
                        <form action="">
                          <div class="form-group">
                            <label for="">
                              <small class="font-weight-light">
                                Content Owner Name
                              </small>
                            </label>
                            <div class="input-group">
                              <BaseInputText
                                v-model="form.owner_name"
                                class="form-control bg-white"
                                name="ownerName"
                                :placeholder="`Content Owner Name`"
                              />
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="">
                              <small class="font-weight-light"
                                >Content Owner Email</small
                              >
                            </label>
                            <div class="input-group">
                              <BaseInputText
                                v-model="form.owner_email"
                                class="form-control bg-white"
                                name="ownerEmail"
                                :placeholder="`Content Owner Email`"
                              />
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="">
                              <small class="font-weight-light">Copyright</small>
                            </label>
                            <div class="input-group">
                              <BaseInputText
                                v-model="form.itunes_copyright"
                                class="form-control bg-white"
                                name="copyright"
                                :placeholder="`Copyright for content`"
                              />
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="">
                              <small class="font-weight-light"
                                >Author Name</small
                              >
                            </label>
                            <div class="input-group">
                              <BaseInputText
                                v-model="form.itunes_author_name"
                                class="form-control bg-white"
                                name="authorName"
                                :placeholder="`Content Author`"
                              />
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-end"
                          >
                            <span
                              v-if="saved"
                              class="badge badge-purple font-weight-normal mr-2 mb-1"
                            >
                              <small class="ml-2 btn-close"
                                ><BaseIcon name="check"
                              /></small>
                            </span>
                            <button
                              :disabled="
                                !form.owner_name ||
                                  !form.owner_email ||
                                  form.owner_name.length === 0 ||
                                  form.owner_email.length === 0 ||
                                  disableUpdateButton
                              "
                              class="btn btn-primary font-weight-normal px-4 my-4"
                              @click.prevent="
                                updateProjectData({
                                  owner_name: form.owner_name,
                                  owner_email: form.owner_email,
                                  itunes_author_name: form.itunes_author_name,
                                  itunes_copyright: form.itunes_copyright,
                                })
                              "
                            >
                              Save Changes
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Default Settings -->
              <div
                id="defaultFunctions"
                class="tab-pane defaultFunctions pt-0"
                role="tabpanel"
                aria-labelledby="defaultFunctions-tab"
              >
                <div>
                  <div class="mb-5">
                    <div class="card bg-light p-4">
                      <div class="row">
                        <div class="col-sm-12 col-md-8">
                          <div
                            class="custom-control custom-checkbox custom-checkbox"
                          >
                            <input
                              id="defaultTurnstile"
                              v-model="turnstileInfo.enabled"
                              type="checkbox"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="defaultTurnstile"
                            >
                              <h4>Default Call-to-Action</h4>
                            </label>
                          </div>
                          <span class="text-gray-input mb-4 d-block"
                            >Collect emails during video playback. All your
                            videos will have this call-to-action</span
                          >

                          <CtaPreview
                            :turnstile-info="turnstileInfo"
                            @hidePreview="false"
                          />
                        </div>

                        <div class="col-sm-12 col-md-4">
                          <TurnstileEditor
                            class="bg-transparent"
                            :turnstile-data="turnstileInfo"
                            :project="project"
                            :default-settings="true"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--
              <div
                id="integrations"
                class="tab-pane integrations pt-0"
                role="tabpanel"
                aria-labelledby="integrations-tab"
              >
                <div>
                  <div class="mb-5">
                    <h3>Integrations</h3>
                  </div>
                </div>
              </div>

              <div
                id="Export"
                class="tab-pane Export pt-0"
                role="tabpanel"
                aria-labelledby="Export-tab"
              >
                <div>
                  <div class="mb-5">
                    <h3>Export</h3>
                  </div>
                </div>
              </div>
              -->
            </TabsContent>
          </template>
        </TabsContainer>
      </div>
    </div>
    <!-- Modal -->
    <SweetModal ref="modal" overlay-theme="dark" width="50%" hide-close-button>
      <div>
        <h4 class="font-weight-bold mt-4 mb-5 text-center">
          Do you really want to remove this Channel?
        </h4>
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div class="d-flex align-items-center justify-content-center w-100">
            <button
              class="btn btn-outline text-gray-input mr-2"
              @click.prevent="closeModal('modal')"
              >Cancel & Return</button
            >
            <button class="btn btn-primary px-5" @click.prevent="deleteProject"
              >Confirm</button
            >
          </div>
        </div>
      </div>
    </SweetModal>
  </Layout>
</template>
